import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Send, Clock, User, Tag, ArrowRight, RefreshCw, Search } from 'lucide-react';
import api from '../../services/api';

const priorityColors = {
  'Düşük': 'bg-slate-100 text-slate-600',
  'Normal': 'bg-blue-100 text-blue-700',
  'Yüksek': 'bg-orange-100 text-orange-700',
  'Acil': 'bg-red-100 text-red-700',
};

export default function LogoTicketsPage() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => { loadTickets(); }, []);

  const loadTickets = async () => {
    try {
      const res = await api.get('/tickets');
      setTickets(res.data.filter(t => t.Status === "Logo'ya İletildi"));
    } catch (err) {}
    setLoading(false);
  };

  const filtered = tickets.filter(t => {
    if (search && !t.Title.toLowerCase().includes(search.toLowerCase()) && !String(t.Id).includes(search)) return false;
    return true;
  });

  if (loading) return <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600" /></div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center">
            <Send size={20} className="text-indigo-600" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-slate-800">Logo'ya İletilen Talepler</h1>
            <p className="text-sm text-slate-500">{tickets.length} talep Logo'ya iletildi</p>
          </div>
        </div>
        <button onClick={loadTickets} className="flex items-center gap-2 px-4 py-2 bg-indigo-50 text-indigo-700 rounded-lg hover:bg-indigo-100 transition-colors text-sm font-medium">
          <RefreshCw size={16} /> Yenile
        </button>
      </div>

      <div className="flex items-center gap-3">
        <div className="relative flex-1 max-w-md">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input type="text" value={search} onChange={e => setSearch(e.target.value)}
            className="w-full pl-9 pr-4 py-2.5 border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder="Talep ara..." />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-12 text-center">
          <Send size={40} className="text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500">Logo'ya iletilmiş talep bulunmuyor</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200">
                <th className="text-left px-5 py-3 text-xs font-semibold text-slate-500 uppercase">#</th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-slate-500 uppercase">Talep</th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-slate-500 uppercase">Kategori</th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-slate-500 uppercase">Öncelik</th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-slate-500 uppercase">Atanan</th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-slate-500 uppercase">İletilme Tarihi</th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-slate-500 uppercase"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {filtered.map(ticket => (
                <tr key={ticket.Id} className="hover:bg-indigo-50/30 transition-colors">
                  <td className="px-5 py-3">
                    <span className="text-sm font-bold text-indigo-600">#{ticket.Id}</span>
                  </td>
                  <td className="px-5 py-3">
                    <p className="text-sm font-medium text-slate-800 truncate max-w-[300px]">{ticket.Title}</p>
                    <p className="text-xs text-slate-400 mt-0.5">{ticket.ContactName || ticket.ContactEmail}</p>
                  </td>
                  <td className="px-5 py-3">
                    <span className="text-xs text-slate-600 flex items-center gap-1"><Tag size={12} />{ticket.Category}</span>
                  </td>
                  <td className="px-5 py-3">
                    <span className={`text-xs px-2 py-1 rounded-full font-medium ${priorityColors[ticket.Priority] || 'bg-slate-100 text-slate-600'}`}>{ticket.Priority}</span>
                  </td>
                  <td className="px-5 py-3">
                    {ticket.AssignedToName ? (
                      <span className="text-xs text-slate-600 flex items-center gap-1"><User size={12} />{ticket.AssignedToName}</span>
                    ) : (
                      <span className="text-xs text-slate-400">—</span>
                    )}
                  </td>
                  <td className="px-5 py-3">
                    <span className="text-xs text-slate-500 flex items-center gap-1">
                      <Clock size={12} />
                      {new Date(ticket.UpdatedAt).toLocaleString('tr-TR', { timeZone: 'Europe/Istanbul', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </td>
                  <td className="px-5 py-3">
                    <Link to={`/staff/tickets/${ticket.Id}`} className="text-indigo-600 hover:text-indigo-800 transition-colors">
                      <ArrowRight size={18} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
